const formatDecimalAmount = (value: string, language: string): string => {
  const [integer, fraction = ''] = value.split('.')
  const whole = BigInt(integer)

  const signedWhole = whole === BigInt(0) && value.startsWith('-') ? -0 : whole

  const fractionText = new Intl.NumberFormat(language, {
    minimumIntegerDigits: 2,
    maximumFractionDigits: 0,
    useGrouping: false,
  }).format(Number(fraction.padEnd(2, '0')))

  return new Intl.NumberFormat(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .formatToParts(signedWhole)
    .map(part => (part.type === 'fraction' ? fractionText : part.value))
    .join('')
}

// Formats an amount given in minor currency units (e.g. cents) without
// converting it to a float, so arbitrarily large `BigInt` values stay exact.
export const formatMinorUnitsAmount = (
  amount: string | number,
  language: string
): string => {
  const minor = BigInt(amount)
  const negative = minor < BigInt(0)
  const absolute = negative ? -minor : minor

  const integer = absolute / BigInt(100)
  const fraction = String(absolute % BigInt(100)).padStart(2, '0')

  return formatDecimalAmount(
    `${negative ? '-' : ''}${integer}.${fraction}`,
    language
  )
}
